import { Request } from "./service"
import { Method } from '../utils';


export const reqApkList = () => {
    return Request(Method.GET, '/api/v1/apks', {}).then(res => {
        return res
    }).catch(err => {
        return err
    })
}